module.exports = "\n  <div class=\"product-head-bar\">\n    <div class=\"ctgry-btn\">\n      <button (click)=\"hideCategoryMobileView($event)\">\n        <span class=\"glyphicon glyphicon-tasks\" aria-hidden=\"true\">\n        </span>{{active ? \"Hide category\" : \"Show Category\"}}\n      </button>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mobile-responsive/mobile-responsive.component.html
// module id = ./src/app/mobile-responsive/mobile-responsive.component.html
// module chunks = main